module.exports = __webpack_public_path__ + "img/image42.a9b264de.jpg";